import Button from 'components/DesignSystem/Button';
import React from 'react';

interface PlusButtonProps {
  id: string
  label: string
  onClick: () => void
  small?: boolean
}

export default function PlusButton({
  id,
  label,
  onClick,
  small = false,
}: PlusButtonProps) {
  return (
    <div className="d-flex align-items-center">
      <Button
        id={id}
        icon="add"
        type="secondary"
        onClick={onClick}
        small={small}
        className="me-2"
      />
      {label}
    </div>
  );
}
